// extracted by mini-css-extract-plugin
module.exports = {"shareLink":"ShareQuote_shareLink__FK0Lg"};